import { Pipe, PipeTransform } from '@angular/core';

/**
 * Transforms the data to show only top three items by priority defined in priorityList object.
 */
@Pipe({ name: 'filter' })
export class FilterPipe implements PipeTransform {
  /**
   * Neki
   */
  public transform(items: Array<any>, searchText: any, property: string): Array<any> {
    if (!items) {
 return [];
}
    if (!searchText) {
 return items;
}
    searchText = searchText.toLowerCase();
    return items.filter(it => it[property].toLowerCase().includes(searchText));
  }
}
